import React from 'react';

import Spinner from 'components/ui/Spinner';

import css from './LoadingSpinner.module.scss';

const LoadingSpinner: React.FC = () => {
    const location = window.location.pathname;

    const authPathnames = ['auth', 'onboarding', 'reset-password', 'verification', 'join'];
    const isAuthLayout = authPathnames.find((pathname) => location.includes(pathname));

    return (
        <div className={css.loadingContainer}>
            <Spinner color={isAuthLayout ? 'white' : 'blue'} />
        </div>
    );
};

export default React.memo(LoadingSpinner);
